import { Component, Input } from '@angular/core';
import { UnitTypes } from '@shared/enums/UnitTypes.enum';
import { FigmaIconComponent } from '@shared/components/figma-icon/figma-icon.component';
import { UnitTypesInterface } from '@modules/settings/unit-types/unit-types.interface';

@Component({
  selector: 'unit-type-icon',
  standalone: true,
  imports: [
    FigmaIconComponent
  ],
  templateUrl: './unit-type-icon.component.html',
  styleUrl: './unit-type-icon.component.scss'
})
export class UnitTypeIconComponent {
  @Input() unitType: UnitTypesInterface;
}
